export default function numberRemoveCommas(val: string): string {
  return val.replaceAll(",", "");
}
